import {BlueGroupAction, GreenCheck, OrangeSettings} from '@assets/icons';
import {Colors} from '@constants/colors.constants';
import {Box, styled, Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';

export enum OfferStatusEnum {
  VALIDATE = 'VALIDATE',
  ANSWERED = 'ANSWERED',
  WAITING = 'WAITING',
}

export interface TagModel {
  status: OfferStatusEnum;
  printableStatus: string;
  color: string;
  colorWithOpacity: string;
  logo: any;
}

const TagReference = (): TagModel[] => [
  {
    status: OfferStatusEnum.VALIDATE,
    printableStatus: 'audits.auditOfferFollowUp.allOffers.processed',
    color: Colors.success,
    colorWithOpacity: alpha(Colors.success, 0.14),
    logo: GreenCheck,
  },
  {
    status: OfferStatusEnum.ANSWERED,
    printableStatus: 'audits.auditOfferFollowUp.allOffers.answered',
    color: Colors.info,
    colorWithOpacity: alpha(Colors.info, 0.14),
    logo: BlueGroupAction,
  },
  {
    status: OfferStatusEnum.WAITING,
    printableStatus: 'audits.auditOfferFollowUp.allOffers.waiting',
    color: Colors.warning,
    colorWithOpacity: alpha(Colors.warning, 0.14),
    logo: OrangeSettings,
  },
];

const OfferTagItemStyled = styled(Box)<{ tag: TagModel }>((props) => {
  const {tag} = props;
  return {
    backgroundColor: tag?.colorWithOpacity,
    borderRadius: '4px',
    padding: '8px 10px',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    height: 'fit-content',
    '& svg': {
      width: '12px',
      height: '12px',
      marginRight: '5px',
    },
  };
});

const OfferTagItem = (props: { tagStatus: OfferStatusEnum; isDetails?: boolean }) => {
  const {t} = useTranslation();
  const {tagStatus, isDetails} = props;
  const tagModel = TagReference().find((tagModel) => tagModel.status === tagStatus);
  if (!tagModel) {
    return null;
  }
  return (
    <OfferTagItemStyled tag={tagModel}>
      <tagModel.logo/>
      <Typography sx={{color: tagModel.color, fontWeight: 400, fontSize: '12px'}}>
        {isDetails ? t('audits.auditOfferFollowUp.allOffers.pending') : t(tagModel.printableStatus)}
      </Typography>
    </OfferTagItemStyled>
  );
};

export default OfferTagItem;
